const chunks = (arr, size) => arr && Array
  .from({ length: Math.ceil(arr.length / size) }, (_, i) => arr.slice(i * size, i * size + size));

const bank_identification_number = (value) => {
  const valid = (value || '').replace(/ /gi, '');
  if (valid.length < 16) return '';
  const splited = valid.substring(0, 16);
  const words = chunks(splited, 4);
  return words
    .map((word, index) => {
      if (index === words.length - 1) {
        const lastFourChars = word.slice(-4);
        return '*'.repeat(word.length - 4) + lastFourChars;
      }
      return '*'.repeat(word.length);
    })
    .join(' ');
};

export {
  chunks,
  bank_identification_number,
};